import React from 'react';
import { useHistory } from 'react-router-dom';
import { CardHeader } from 'reactstrap';

const BackToOrganisationList = (props) => {
    let { prevLocation, portalSearchObject } = props;
    const history = useHistory();

    return (
        <CardHeader className="card-header card-header--no-icon">
            <div>
                <button
                    className="c-back-button"
                    onClick={
                        () => history.push(prevLocation, { portalSearchObject: portalSearchObject })
                    }
                >
                    {'Back to Organisation List'}
                </button>
            </div>
        </CardHeader>
    )
}

export default BackToOrganisationList;